// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3FW4R","location":"Header_location__1ONag"};